// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "remuner-services.firebaseapp.com",
  projectId: "remuner-services",
  storageBucket: "remuner-services.firebasestorage.app",
  messagingSenderId: "957147985885",
  appId: "1:957147985885:web:f7d11d78d01625f6136834"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
auth.languageCode = "es";

export { auth, analytics, RecaptchaVerifier, signInWithPhoneNumber };